export enum UTMSourceEnum {
	SharedLink = 'shared_link',
	RefferedUser = 'reffered_user',
	RefferedTeam = 'reffered_team',
	Organic = 'organic',
	Social = 'social',
	Email = 'email',
	Web = 'web',
	Mobile = 'mobile',
}
